import LegalLayout from "../components/LegalLayout";

const PrivacyPage = () => (
  <LegalLayout title="Privacy Policy">
    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">Overview</h2>
      <p>
        apitomcpconverter.com helps you convert API specifications into MCP servers. This policy
        explains what we collect, how we use it, and the choices you have when you use the site.
      </p>
    </section>

    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">Information we collect</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Account details when you sign in, such as your email address and display name.</li>
        <li>Profile information from Google when you choose Continue with Google.</li>
        <li>Registry activity such as stars, downloads, and comments tied to your account.</li>
        <li>Uploaded or pasted API specifications and related conversion inputs you submit.</li>
        <li>Technical data such as cookies, browser type, and basic usage or analytics events.</li>
      </ul>
    </section>

    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">How we use information</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Authenticate you and keep your session secure.</li>
        <li>Operate conversion, hosting, registry, and support features you request.</li>
        <li>Improve reliability, security, and product performance.</li>
        <li>Respond to feedback or support requests you send us.</li>
      </ul>
    </section>

    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">Sharing and retention</h2>
      <p>
        We use service providers such as hosting, authentication, and database vendors to run the
        product. We do not sell your personal information. We keep data only as long as needed for
        the purposes above or as required by law.
      </p>
    </section>

    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">Your choices</h2>
      <p>
        You may sign out at any time. You may contact us to request access, correction, or deletion
        of account information where applicable law allows.
      </p>
    </section>
  </LegalLayout>
);

export default PrivacyPage;
